export default {
    'admin': {
        steps: [
            {
                key: 1,
                name: 'Hallo',
                component: {
                    name: 'WizardAdminFirstStep',
                    title: 'Hallo!',
                    description:
                        'Ich führe Dich durch die Ersteinrichtung, damit Du STARFACE UP <br/> schnell starten kannst.',
                    image: '1-1'
                }
            },
            {
                key: 2,
                name: 'Rufnummer',
                component: {
                    name: 'WizardAdminSecondStep',
                    title: 'Lege jetzt Deine Rufnummer fest',
                    description:
                        'Du hast die freie Wahl! Wähle die Durchwahl, die am <br/> besten zu Dir passt!',
                    image: '1-2'
                }
            },
            {
                key: 3,
                name: 'Fertig',
                component: {
                    name: 'WizardAdminThirdStep',
                    title: 'Tadaaaaaaaaa!',
                    description:
                        'Herzlichen Glückwunsch, Du bist nun stolzer Besitzer der Rufnummer',
                    description2: '<b>Deine Rufnummer ist ebenfalls Deine Login-ID.</b> Diese brauchst Du, um Dich in dem Client oder in der App einloggen zu können.',
                    contentText:
                        'Noch bist Du ganz alleine. Um mit Deinen Kollegen telefonieren zu können, Videosharing zu nutzen oder zu chatten brauchst Du weitere Benutzer – lege sie jetzt an!',
                    image: '1-3'
                }
            },
        ]
    },
    'first-user': {
        steps: [
            {
                key: 1,
                name: 'Benutzerdaten',
                component: {
                    name: 'WizardUserFirstStep',
                    title: 'Wen haben wir denn da?',
                    description:
                        'Gib hier die Daten Deines Kollegen / Deiner Kollegin ein, mit der Du </br> als erstes über STARFACE UP telefonieren, chatten oder Dateien </br> austauschen möchtest.',
                    image: '2-1'
                }
            },
            {
                key: 2,
                name: 'Rufnummer',
                component: {
                    name: 'WizardUserSecondStep',
                    title: 'Lege jetzt die Rufnummer fest',
                    description: 'Welche Durchwahl möchtest Du vergeben?',
                    image: '2-2'
                }
            },
            {
                key: 3,
                name: 'Fertig',
                component: {
                    name: 'WizardUserThirdStep',
                    title: 'Geschafft!',
                    description:
                        'Du hast einen zweiten Benutzer angelegt und kannst nun <br/> ohne Ende telefonieren, chatten und Videokonferenzen machen! <br/><br/> Wir haben dem neuen Benutzer eine E-Mail mit seinen <br/>Zugangsdaten geschickt, damit er sich freischalten kann.',
                    contentText:
                        'Weißt Du, was Dir noch fehlt? Ein dritter Benutzer für Deine erste Telefonkonferenz! Leg ihn gleich an!',
                    image: '2-4'
                }
            },
        ]
    },
    'second-user': {
        steps: [
            {
                key: 1,
                name: 'Benutzerdaten',
                component: {
                    name: 'WizardUserFirstStep',
                    title: 'Neuer Benutzer, neues Glück!',
                    description:
                        'Du kennst das Prozedere ja schon - <br/> gib hier die Daten des neuen Benutzers ein',
                    image: '3-1'
                }
            },
            {
                key: 2,
                name: 'Rufnummer',
                component: {
                    name: 'WizardUserSecondStep',
                    title: 'Lege jetzt die Rufnummer fest',
                    description: 'Welche Durchwahl möchtest Du vergeben?',
                    image: '3-2'
                }
            },
            {
                key: 3,
                name: 'Fertig',
                component: {
                    name: 'WizardUserThirdStep',
                    title: 'Geschafft!',
                    description:
                        'Du hast nun drei Benutzer angelegt und kannst somit alle Funktionen von STARFACE UP nutzen. <br/> <br/>Wir wünschen Dir viel Spaß!',
                    contentText: '',
                    image: '3-4'
                }
            },
        ]
    }
};
